import React from "react";
import { Helmet } from "react-helmet";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import FileUnderContainer from "~/Containers/FileUnderContainer";
import Tile from "../../Components/Tile";
const FileUnderPage = ({ match }) => {
  const { slug } = match.params;

  return (
    <div className="home-page-component">
      <div className="home-component">
        <FileUnderContainer
          slug={slug}
          infinite
          componentType={Tile}
          render={({ items, loadMore, data, loading }) => (
            <div>
              <Helmet>{data?.tagName && <title>____ of the Day | {data.tagName} | Dream Chimney</title>}</Helmet>
              {data?.tagName && (
                <div className="pageTitle">
                  File Under: "{data.tagName}" ({data.total})
                </div>
              )}

              <Row noGutters className="minimalGutter">
                {items &&
                  items.map((item) => (
                    <Col xl={4} lg={6} xs={12} key={item.id}>
                      <Tile archive otd={item} />
                    </Col>
                  ))}
              </Row>
              <div>{loadMore}</div>
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default FileUnderPage;
